export default __webpack_public_path__ + "static/media/catherine-george.cf082918.jpg";